import { render, staticRenderFns } from "./starbucks.vue?vue&type=template&id=694cf151&scoped=true"
import script from "./starbucks.vue?vue&type=script&lang=js"
export * from "./starbucks.vue?vue&type=script&lang=js"
import style0 from "./starbucks.vue?vue&type=style&index=0&id=694cf151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694cf151",
  null
  
)

export default component.exports